import { Heading } from "@tokenterminal/core/ui/heading/Heading"
import { Box, type BoxProps } from "@tokenterminal/ui/Box"
import { Stack } from "@tokenterminal/ui/Stack"
import { withOverflow } from "@tokenterminal/ui/util.css"
import { type ReactNode } from "react"

export function WidgetContent({
  children,
  spacing,
  ...props
}: { children: ReactNode; spacing: BoxProps["padding"] } & BoxProps) {
  return (
    <Box height="100%" className={withOverflow} width="100%" {...props}>
      <Stack gap={["3x", "4x"]} paddingX={spacing} height="100%">
        {children}
      </Stack>
    </Box>
  )
}

export function WidgetHeader({
  children,
  isExpanded = true,
}: {
  children: ReactNode
  isExpanded?: boolean
}) {
  return (
    <Heading level={3} as="h2" className="!text-xs text-fg-secondary w-full">
      {children}
    </Heading>
  )
}
